import { lazy } from 'react';

const Layout = lazy(() => import('./Layout'));

export { Layout };
